div#success-state-container {
  max-width: 840px;
  padding-top: calc(var(--spacer) * 4);
}

div#error-state-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gz-image-repo {
    height: auto;
  }

  gz-text {
    text-align: center;
  }
}

gz-info-box {
  &::part(container) {
    width: 800px;
  }
  padding-right: 0;
}

gz-enum-filter#security-servers-filter {
  width: 800px;
}

div#filter-and-add-button-container {
  width: 888px;
}

gz-data-table {
  --cell-padding: 0 calc(var(--spacer) * 2) 0 0;
  --column-max-width: 720px;
}

gz-info-box {
  padding: calc(var(--spacer) * 2) 0;
}
